import { Injectable } from '@angular/core';
import { User } from '../shared/models/user';
import { API_ENDPOINTS } from '../shared/common/apiConstants';
import { ServiceBase } from '../shared/models/bases/serviceBase';
import { UserStore } from '../stores';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService extends ServiceBase<User> {
  constructor(userStore: UserStore) {
    super(API_ENDPOINTS.auth.register, userStore);
  }

  activateUser(body: any) {
    return this.postGeneric<{ token: string }, { message: string }>(
      body,
      `${this.baseUrl}${API_ENDPOINTS.auth.activate}`,
    );
  }
}
